import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import * as Yup from "yup";
import { handleSubmit } from "../../../../services/utils/processors";
import styled from "styled-components";
import { FormWrapper, ActionRow } from "../form.styles";

const SkillsField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledChips = styled(Chips)`
  width: 100%;
  .p-chips-token {
    margin: 5px !important;
  }
`;

const Skills = ({ dbData = null, loading = false, onSave, onBack }) => {
  const [skills, setSkills] = useState([]);
  const [skillsError, setSkillsError] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const dbSkillsKey = JSON.stringify(dbData || []);

  useEffect(() => {
    setSkills(Array.isArray(dbData) ? dbData.map(skill => typeof skill === 'string' ? skill : skill.name) : []);
    setSkillsError({});
  }, [dbSkillsKey]);

  useEffect(() => {
    const dbSkillsNames = (dbData || []).map(skill => skill.name?.trim() || '');
    setIsDirty(JSON.stringify([...skills].map(skill => skill?.trim() || '').sort()) !== JSON.stringify([...dbSkillsNames].sort()));
  }, [skills, dbSkillsKey]);

  const schema = Yup.array().of(
    Yup.object({ name: Yup.string().required("Skill name is required") })
  );

  const handleSubmitData = () => {
    const hasErrors = handleSubmit(skills.map(skill => ({ name: skill })), schema, setSkillsError, onSave);
    if (hasErrors && Object.keys(hasErrors).length > 0) {
      // Error occurred
    }
  };

  return (
    <FormWrapper>
      <SkillsField>
        <label className="font-bold">Add your skills (Press Enter after each skill)</label>
        <StyledChips
          value={skills}
          onChange={(e) => setSkills(e.value)}
          placeholder="E.g. JavaScript, React, Python..."
        />
        {skillsError?.name && <small className="p-error">{skillsError.name}</small>}
      </SkillsField>

      <ActionRow>
        {onBack && <Button label="Back" icon="pi pi-arrow-left" severity="secondary" onClick={onBack} disabled={loading} />}
        {isDirty && <Button label="Save" icon="pi pi-save" loading={loading} disabled={loading} className="p-button-success" onClick={handleSubmitData} />}
      </ActionRow>
    </FormWrapper>
  );
};

export default Skills;

